import { render, staticRenderFns } from "./HomepageChrome.vue?vue&type=template&id=2642569b"
import script from "./HomepageChrome.vue?vue&type=script&lang=js"
export * from "./HomepageChrome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports